import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import Modal from '../components/Modal'

export default function PlanTOB() {
    const state = useSelector(state => state.miCustomerSharedReducer);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    let individualPlansTOB = state.individualPlansTOB;
    return (
        <>


            <div className="table-responsive">
                <table className="table table-hover table-custom">
                    <thead className="table-header">
                        <tr>
                            {/* <th>
                                    <div className="form-check">
                                        <input
                                            type="checkbox"
                                            id="CheckAll"
                                            className="form-check-input"
                                            onChange={value => handleAllMemberCheckboxChange(value)}
                                        />
                                    </div>
                                </th> */}
                            <th className="text-center">S No.</th>
                            <th className="text-center">Benefit Name </th>
                            <th className="text-center">Benefit Value</th>


                        </tr>
                    </thead>
                    {individualPlansTOB?.currentPlanTOB?.length != 0 ? (
                        <tbody>
                            {individualPlansTOB?.currentPlanTOB?.map((result, index) => (
                                <tr key={result.srlNo} className="table-row">
                                    <td> {(Number(index) + Number(1))} </td>
                                    <td> {result.benefitType} </td>
                                    <td> {result.benefitValue == null ? "-" : result.benefitValue}</td>
                                </tr>
                            ))}
                        </tbody>
                    ) : (
                        <tbody>
                            <tr>
                                <td colSpan="8" className="text-center">
                                    <div className="alert alert-warning">No Benifits Found...</div>
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>

        </>
    )
}